import React from 'react';

const Technologies = () => {
  const techCategories = [
    {
      title: 'Cloud Providers',
      logos: [
        { name: 'AWS', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg', colored: true },
        { name: 'Azure', logo: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Microsoft_Azure.svg', colored: true },
        { name: 'Google Cloud', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/51/Google_Cloud_logo.svg', colored: true }
      ]
    },
    {
      title: 'AI & Machine Learning',
      logos: [
        { name: 'OpenAI', text: 'OpenAI' },
        { name: 'TensorFlow', text: 'TensorFlow' },
        { name: 'PyTorch', text: 'PyTorch' },
        { name: 'Anthropic', text: 'Anthropic' }
      ]
    },
    {
      title: 'Development & DevOps',
      logos: [
        { name: 'Docker', text: 'Docker' },
        { name: 'Kubernetes', text: 'Kubernetes' },
        { name: 'GitHub', text: 'GitHub' },
        { name: 'Jenkins', text: 'Jenkins' }
      ]
    },
    {
      title: 'Databases',
      logos: [
        { name: 'MongoDB', text: 'MongoDB' },
        { name: 'PostgreSQL', text: 'PostgreSQL' },
        { name: 'Redis', text: 'Redis' },
        { name: 'Snowflake', text: 'Snowflake' }
      ]
    }
  ];

  return (
    <section id="technologies" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Tecnologías de vanguardia
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Trabajamos con las últimas tecnologías del mercado para garantizar soluciones robustas y escalables
          </p>
        </div>

        {/* Technologies Grid */}
        <div className="space-y-12">
          {techCategories.map((category, idx) => (
            <div key={idx}>
              <h3 className="text-2xl font-bold text-[#ff6b35] mb-6 text-center">
                {category.title}
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {category.logos.map((tech, index) => (
                  <div
                    key={index}
                    className="group bg-white backdrop-blur-sm border border-gray-200 rounded-xl p-6 flex items-center justify-center hover:border-[#ff6b35] transition-all duration-300 hover:shadow-lg hover:shadow-[#ff6b35]/20 hover:-translate-y-1"
                  >
                    {tech.logo ? (
                      <img 
                        src={tech.logo} 
                        alt={tech.name}
                        className={`h-12 w-auto object-contain ${
                          tech.colored ? '' : 'filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100'
                        } transition-all`}
                      />
                    ) : (
                      <span className="text-lg font-bold text-gray-700 group-hover:text-[#ff6b35] transition-colors">
                        {tech.text}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Awards Section */}
        <div className="mt-20">
          <div className="bg-gradient-to-r from-orange-50 to-white rounded-2xl p-12 border border-orange-200 text-center">
            <h3 className="text-3xl font-bold text-gray-900 mb-8">Lo que nos diferencia</h3>
            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <div className="text-4xl mb-3">🏆</div>
                <p className="text-gray-700 font-medium">Certificaciones en AWS, Azure y Google Cloud</p>
              </div>
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <div className="text-4xl mb-3">⭐</div>
                <p className="text-gray-700 font-medium">Partners certificados de las principales plataformas tecnológicas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technologies;